import React from "react"
import { connect } from "react-redux"
import { MainActions, AuthActions } from "redux-store/models"
import moment from "moment"
import {
  Icon,
  Table,
  Select,
  Pagination,
  Input,
  Button,
  notification,
  TreeSelect,
  Checkbox,
  Popover,
  Tooltip,
  Modal,
  Tag,
} from "antd"
import "antd/dist/antd.css"
import ModalResponsiveForTables from "shared-components/ModalResponsiveForTables/ModalResponsiveForTables"
import SpanFormater from "shared-components/SpanFormater/SpanFormater"
import ModalRow from "shared-components/ModalResponsiveForTables/ModalRow"
import Excel from "./Excel"
import Pdf from "./Pdf"
import { Loader } from "shared-components"
import { numberWithCommas } from "utils/HelperFunc"
import CalendarRangePicker from "shared-components/CalendarRangePicker/CalendarRangePicker"
import { isArray } from "lodash"
import { withRouter } from "react-router"
import { baseUrlImg } from "../../config/api"
import CancelServiceForm from "../../shared-components/adminSharedComp/CancelServiceForm"
import SkinSelectRow from "../../shared-components/SkinSelect/SkinSelectRow"

const { Option } = Select

export const UtenteCell = ({ icon, Word, title, color }) => {
  return (
    <div className="utente-data" title={title}>
      <i style={{ WebkitTextStroke: `2px ${color}` }} className={icon} />
      <div className="utente-word">{Word}</div>
    </div>
  )
}

const today = new Date().toISOString().split("T")[0]
class TransazioniAdmin extends React.Component {
  constructor() {
    super()
    this.state = {
      tabFilter: "",
      modal: false,
      searchText: "",
      searchedColumn: "",
      visible: false,
      username: "",
      usernames: null,
      service: "",
      provider: "",
      barcode: "",
      name: "",
      address: "",
      phone: "",
      from: today,
      to: today,
      modalDetails: "",
      fromLabel: moment(today).format("DD/MM/YYYY"),
      toLabel: moment(today).format("DD/MM/YYYY"),
      perPage: 25,
      showModalResponsive: false,
      activeCategory: null,
      selectedRecord: null,
      cancelModalOpen: false,
      paymentMethod: "",
      serviceSearch: "",
      picker: [
        {
          startDate: new Date(),
          endDate: new Date(),
          key: "selection",
          color: "var(--accent-bg)",
        },
      ],
      //1 for movimenti , 2 for refills
      tableType: 1,
      movimentiVisibleColumns: {
        "Date / Ora": true,
        Barcode: true,
        Utente: true,
        Provider: true,
        Brand: false,
        Service: true,
        Category: false,
        Utile: {
          Importo: true,
          Commissione: true,
          Provvigione: true,
          Agente: true,
          Skin: true,
          Sistema: true,
        },
        Saldo: true,
        Adyen: false,
        "Check Crypto": true,
        // Refund: false,
        Cancella: true,
      },
    }
  }
  setCalendar = (val) => {
    this.setState({ isCalendarOpen: val })
  }

  hideModal = () => {
    document.body.style.overflow = ""
    this.setState({ modal: false })
  }

  showModal = () => {
    document.body.style.overflow = "hidden"
    this.setState({ modal: true })
  }

  selectTab = (payload) => {
    this.setState({ tabFilter: payload })
  }
  componentDidMount() {
    const { username } = this.props.match.params
    const { service, activeCategory, from, to } = this.state
    const { skinList, accountInfo, activeSkinId } = this.props

    const role = accountInfo?.profile?.role?.name
    const activityId = accountInfo?.profile?.activity_id

    this.setState({ username })

    this.props.getServicesTree()

    const getSkinId = () => {
      if (role === "super_admin" || role === "agent") {
        return activityId ?? 2
      }

      const activeSkins = skinList.filter((s) => s.status === 1)

      return activeSkinId !== -1
        ? activeSkinId
        : activeSkins.length > 0
          ? activeSkins[0]?.id
          : undefined
    }

    if (skinList.length > 0) {
      const skinId = getSkinId()

      this.props.getPayments(
        username || "",
        from,
        to,
        1,
        25,
        skinId,
        null,
        service,
        null,
        activeCategory !== "TUTTI" ? activeCategory : null,
        null,
        null,
        activeSkinId === -1 ? true : undefined,
      )
    }

    if ((role === "super_admin" || role === "agent") && activeSkinId !== undefined) {
      const skinId = getSkinId()

      this.props.getPayments(
        username || "",
        from,
        to,
        1,
        25,
        skinId,
        null,
        service,
        null,
        activeCategory !== "TUTTI" ? activeCategory : null,
        null,
        null,
        null,
      )
    }

    this.props.getAllServices(activeSkinId !== -1 ? activeSkinId : 2, null, 1, 1, 50)
  }

  componentDidUpdate(prevProps, prevState) {
    const { username, from, to, perPage, service, activeCategory } = this.state
    const { activeSkinId, skinList, fromDate } = this.props

    const getFirstActiveSkinId = () => {
      const list = skinList.filter((s) => s.status === 1)
      return list.length > 0 ? list[0].id : undefined
    }

    if (skinList !== prevProps.skinList && activeSkinId === -1) {
      const id = getFirstActiveSkinId()
      if (id) this.props.setActiveSkinId(id)
    }

    if (activeSkinId !== prevProps.activeSkinId) {
      this.props.getPayments(
        username || "",
        from || today,
        to || today,
        1,
        perPage || 10,
        activeSkinId === -1 ? null : activeSkinId,
        null,
        service || "",
        null,
        activeCategory !== "TUTTI" ? activeCategory : null,
        null,
        null,
        activeSkinId === -1 ? true : undefined,
      )

      const skinId = activeSkinId === -1 ? getFirstActiveSkinId() : activeSkinId

      if (skinId) {
        this.props.getAllServices(skinId, null, 1, 1, 50)
      }
    }

    if (fromDate && fromDate !== prevProps.fromDate) {
      const label = moment(fromDate, "DD/MM/YYYY")

      this.setState({
        from: fromDate,
        to: fromDate,
        fromLabel: label,
        toLabel: label,
        perPage: 25,
      })
    }
    if (this.state.serviceSearch !== prevState.serviceSearch) {
      clearTimeout(this.searchTimeout)

      this.searchTimeout = setTimeout(() => {
        const { activeSkinId } = this.props

        this.props.getAllServices(
          activeSkinId === -1 ? 2 : activeSkinId,
          null,
          1,
          1,
          50,
          this.state.serviceSearch,
        )
      }, 500)
    }
  }

  getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => {
      if (dataIndex === "service") {
        return (
          <div
            style={{ padding: 8, width: "300px" }}
            className="table-filter-dropdown"
          >
            <Select
              mode="combobox"
              allowClear
              showSearch
              style={{ width: "100%" }}
              placeholder={`Search ${dataIndex}`}
              value={this.state.service}
              onChange={(value) => {
                this.setState({ service: value || "" })
                setSelectedKeys(value ? [value] : [])
              }}
              filterOption={(input, option) =>
                option.props.children.toLowerCase().includes(input.toLowerCase())
              }
            >
              {this.props.listedServices.map((option) => (
                <Option key={option} value={option} title={option}>
                  {option}
                </Option>
              ))}
            </Select>

            <Button
              type="primary"
              onClick={() =>
                this.handleSearch(
                  this.state.service ? [this.state.service] : [],
                  confirm,
                  dataIndex,
                )
              }
              icon="search"
              size="small"
              style={{ marginTop: 8, width: "100%" }}
            >
              Search
            </Button>
          </div>
        )
      }

      if (dataIndex === "provider_name") {
        return (
          <div
            style={{ padding: 8, width: "180px" }}
            className="table-filter-dropdown"
          >
            <Select
              mode="single"
              allowClear
              showSearch
              style={{ width: "100%" }}
              placeholder={`Search ${dataIndex}`}
              value={selectedKeys}
              onChange={(value) => {
                setSelectedKeys(value)
                this.setState({ provider: value || "" })
              }}
            >
              {this.props?.listedProviders?.map((option) => (
                <Option key={option.key} value={option.name}>
                  {option.name}
                </Option>
              ))}
            </Select>
            <Button
              type="primary"
              onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
              icon="search"
              size="small"
              style={{ marginTop: 8, width: "100%" }}
            >
              Search
            </Button>
          </div>
        )
      }

      if (dataIndex === "utente") {
        return (
          <div
            style={{ padding: 8, width: "180px" }}
            className="table-filter-dropdown"
          >
            <Select
              mode="combobox"
              allowClear
              showSearch
              style={{ width: "100%" }}
              placeholder={`Search ${dataIndex}`}
              value={this.state.username}
              onChange={(value) => {
                this.setState({ username: value || "" })
                setSelectedKeys(value ? [value] : [])
              }}
              filterOption={(input, option) =>
                option.props.children.toLowerCase().includes(input.toLowerCase())
              }
            >
              {Array.isArray(this.props.usernames)
                ? this.props.usernames.map((username, index) => (
                    <Option key={index} value={username}>
                      {username}
                    </Option>
                  ))
                : Object.entries(this.props.usernames).map(([key, value]) => (
                    <Option key={key} value={key}>
                      {value}
                    </Option>
                  ))}
            </Select>

            <Button
              type="primary"
              onClick={() => {
                const value = this.state.username || ""
                this.handleSearch(value ? [value] : [], confirm, dataIndex)
              }}
              icon="search"
              size="small"
              style={{ marginTop: 8, width: "100%" }}
            >
              Search
            </Button>
          </div>
        )
      }

      return (
        <div style={{ padding: 8 }}>
          <Input
            ref={(node) => {
              this.searchInput = node
            }}
            placeholder={`Search ${dataIndex}`}
            value={selectedKeys[0]}
            onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
            onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
            style={{ width: 188, marginBottom: 8, display: "block" }}
          />
          <Button
            type="primary"
            onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
            icon="search"
            size="small"
            style={{ width: 90, marginRight: 8 }}
          >
            Search
          </Button>
          <Button
            onClick={() => this.handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
        </div>
      )
    },

    filterIcon: (filtered) => (
      <Icon type="search" style={{ color: filtered ? "#1890ff" : undefined }} />
    ),

    onFilter: (value, record) => {
      const cell = record[dataIndex]

      if (cell == null) return false

      if (typeof cell === "object" && "props" in cell) {
        const word =
          cell.props?.Word?.props?.Word ??
          cell.props?.Word ??
          cell.props?.children ??
          ""
        return word?.toString()?.toLowerCase()?.includes(value?.toLowerCase())
      }

      return cell.toString()?.toLowerCase()?.includes(value?.toLowerCase())
    },

    render: (text) => (this.state.searchedColumn === dataIndex ? text : text),
  })

  handleSearch = (selectedKeys, confirm, dataIndex) => {
    const {
      to,
      from,
      perPage,
      service,
      username,
      activeCategory,
      provider,
      paymentMethod,
    } = this.state
    const isCard =
      paymentMethod === "card" ? true : paymentMethod === "wallet" ? false : null

    confirm()
    if (dataIndex == "utente") {
      this.props.getPayments(
        username,
        from || today,
        to || today,
        1,
        perPage,
        this.props.activeSkinId === -1 ? null : this.props.activeSkinId,
        "",
        service == "TUTTI" ? "" : service,
        null,
        activeCategory !== "TUTTI" ? activeCategory : null,
        null,
        provider ? provider : "",
        this.props.activeSkinId === -1 ? true : undefined,
        isCard,
      )
    } else if (dataIndex == "service") {
      this.props.getPayments(
        username ? username : "",
        from || today,
        to || today,
        1,
        perPage,
        this.props.activeSkinId === -1 ? null : this.props.activeSkinId,
        "",
        service == "TUTTI" ? "" : service,
        null,
        activeCategory !== "TUTTI" ? activeCategory : null,
        null,
        provider ? provider : "",
        this.props.activeSkinId === -1 ? true : undefined,
        isCard,
      )
    } else if (dataIndex == "provider_name") {
      this.props.getPayments(
        username ? username : "",
        from || today,
        to || today,
        1,
        perPage,
        this.props.activeSkinId === -1 ? null : this.props.activeSkinId,
        "",
        service == "TUTTI" ? "" : service,
        null,
        activeCategory !== "TUTTI" ? activeCategory : null,
        null,
        provider ? provider : "",
        this.props.activeSkinId === -1 ? true : undefined,
        isCard,
      )
    } else if (dataIndex == "barcode") {
      this.props.getCodiceTicket(selectedKeys[0], "omeLale")
    } else {
      this.setState({
        searchText: selectedKeys[0],
        searchedColumn: dataIndex,
      })
    }
  }

  handleReset = (clearFilters) => {
    clearFilters()
    this.setState({ searchText: "", username: "", service: "" })
  }

  handleTableChange = (pagination, filters) => {
    const { to, from, username, service, perPage, activeCategory, provider } =
      this.state

    const { activeSkinId } = this.props
    const value = filters.importo?.[0] || ""

    this.setState(
      {
        paymentMethod: value,
      },
      () => {
        const isCard = value === "card" ? true : value === "wallet" ? false : null

        this.props.getPayments(
          username !== "" ? username : "",
          from || today,
          to || today,
          1,
          perPage,
          activeSkinId === -1 ? null : activeSkinId,
          "",
          service !== "" && service != "TUTTI" ? service : "",
          null,
          activeCategory !== "TUTTI" ? activeCategory : null,
          null,
          provider ? provider : "",
          activeSkinId === -1 ? true : null,
          isCard,
        )
      },
    )
  }

  handleSubmit = async (e, refills) => {
    const {
      username,
      to,
      from,
      perPage,
      service,
      activeCategory,
      provider,
      paymentMethod,
    } = this.state
    const isCard =
      paymentMethod === "card" ? true : paymentMethod === "wallet" ? false : null

    e.preventDefault()
    if (refills) {
      await this.setState({ tableType: 2 })
      this.props.getRefills(1, perPage)
    } else {
      await this.setState({ tableType: 1 })

      if (this.props.forAdmin) {
        this.props.getPayments(
          username,
          from || today,
          to || today,
          1,
          perPage,
          this.props.activeSkinId === -1 ? null : this.props.activeSkinId,
          "",
          service == "TUTTI" ? "" : service,
          null,
          activeCategory !== "TUTTI" ? activeCategory : null,
          null,
          provider ? provider : "",
          this.props.activeSkinId === -1 ? true : undefined,
          isCard,
        )
      } else {
        this.props.getPayments(
          username,
          from || today,
          to || today,
          1,
          perPage,
          "",
          "",
          service == "TUTTI" ? "" : service,
          null,
          activeCategory !== "TUTTI" ? activeCategory : null,
          null,
          provider ? provider : "",
        )
      }
    }
  }

  componentWillUnmount() {
    if (this.props.forAdmin === true) {
      this.props.openModalForAdmin(false)
      this.props.editModalDetails({})
    }
    this.props.setFromDateToDate(null)
    clearTimeout(this.searchTimeout)
  }

  activateModalForAdmin = (item, index) => {
    this.props.openModalForAdmin(true)
    this.props.editModalDetails({
      index,
      barcode: item.barcode,
      agency_name: item.agency_name,
      address: item.agency_address,
    })
  }

  handleDateChange = (date) => {
    this.setState({ from: date, to: date })
  }

  transformToTreeData = (categories) => {
    return categories
      .filter((category) => category.full_name !== "Uncategorized")
      .map((category) => ({
        title: category.full_name ?? category.name,
        value: category.id.toString(),
        children: this.transformToTreeData(category.children_recursive),
      }))
  }

  transformData = (data) => {
    return Object.entries(data).map(([providerName, categories]) => ({
      title: providerName,
      value: providerName,
      children: Object.values(categories).flatMap((companies) =>
        companies.map((company) => ({
          title: company.full_name ?? company.name,
          value: company.id.toString(),
        })),
      ),
    }))
  }

  getAllCategoryIds = (node, values = []) => {
    if (!node) return values

    values.push(node.value)

    if (node.children && node.children.length > 0) {
      node.children.forEach((child) => this.getAllCategoryIds(child, values))
    }

    return values
  }

  findNodeByValue = (tree, value) => {
    for (const node of tree) {
      if (node.value === value) {
        return node
      }

      if (node.children && node.children.length > 0) {
        const found = this.findNodeByValue(node.children, value)
        if (found) return found
      }
    }
    return null
  }

  handleCheckboxChange = (e, colKey, subKey) => {
    this.setState((prevState) => {
      const updatedColumns = { ...prevState.movimentiVisibleColumns }

      if (subKey) {
        updatedColumns[colKey][subKey] = e.target.checked
      } else {
        updatedColumns[colKey] = e.target.checked
      }

      return { movimentiVisibleColumns: updatedColumns }
    })
  }

  handleCheckAll = (colKey) => {
    this.setState((prevState) => {
      const updatedColumns = { ...prevState.movimentiVisibleColumns }
      const group = updatedColumns[colKey]
      const allChecked = Object.values(group).every(Boolean)
      const newState = !allChecked

      Object.keys(group).forEach((subKey) => {
        group[subKey] = newState
      })

      updatedColumns[colKey] = group
      return { movimentiVisibleColumns: updatedColumns }
    })
  }

  render() {
    const { forAdmin, paymentsForExcel, screenWidth } = this.props
    const {
      picker,
      isCalendarOpen,
      fromLabel,
      toLabel,
      to,
      from,
      username,
      service,
      perPage,
      modalDetails,
      tableType,
      activeCategory,
      movimentiVisibleColumns,
      selectedRecord,
      cancelModalOpen,
    } = this.state

    const {
      payments,
      accountInfo,
      loadingPayments,
      paymentsPages,
      getCodiceTicket,
      getPayments,
      activeSkinId,
      servicesTree,
      checkCrypto,
      listedServices,
      brands,
      balance,
      allServices,
    } = this.props

    console.log(this.props.selectedCompany)

    const treeData = allServices
      ?.filter((service) => service.active === 1)
      .map((service) => ({
        title: service.full_name || service.name,
        value: service.number_id,
        key: service.number_id,
      }))

    const companies = allServices
      ?.filter((service) => service.active === 1)
      .map((service) => ({
        id: service.number_id,
        name: service.full_name || service.name,
      }))

    console.log(companies)

    const paymentsO =
      payments &&
      isArray(payments) &&
      payments.sort(function (a, b) {
        return new Date(b.executed_date) - new Date(a.executed_date)
      })

    const totalcolumns = [
      {
        title: "Importo Totale",
        dataIndex: "total_importo",
        key: "total_importo",
        render: (text) => {
          return `${text}€`
        },
        align: "center",
      },
      {
        title: "Total Comm.",
        dataIndex: "total_comm",
        key: "total_comm",
        render: (text) => {
          return `${text}€`
        },
        align: "center",
      },
      {
        title: "Nr servizi",
        dataIndex: "total_services",
        key: "total_services",
        align: "center",
      },
      {
        title: "Provvigione Agenzia",
        dataIndex: "total_agency_guadagno",
        key: "total_agency_guadagno",
        render: (text) => {
          return `${text}€`
        },
        align: "center",
      },
      {
        title: "Provvigione Agente",
        dataIndex: "total_agent_profit",
        key: "total_agent_profit",
        render: (text) => {
          return `${text}€`
        },
        align: "center",
      },
      accountInfo.profile.role.name !== "agent" && {
        title: "Guadagno Skin",
        dataIndex: "total_skin_guadagno",
        key: "total_skin_guadagno",
        render: (text) => {
          return `${text}€`
        },
        align: "center",
      },
      accountInfo.profile.role.name !== "agent" &&
        accountInfo.profile.role.name !== "super_admin" && {
          title: "Aggio Sistema",
          dataIndex: "total_system_aggio",
          key: "total_system_aggio",
          render: (text) => {
            return `${text}€`
          },
          align: "center",
        },
    ].filter(Boolean)

    const totaldata = balance &&
      Object.keys(balance).length > 0 && [
        {
          total_importo: balance?.total_importo,
          total_agency_guadagno: balance?.total_agency_guadagno,
          total_comm: balance?.total_comm,
          total_agent_profit: balance?.total_agent_profit,
          total_skin_guadagno: balance?.total_skin_guadagno,
          total_system_aggio: balance?.total_system_aggio,
          total_services: paymentsPages?.total_records,
        },
      ]

    var columns =
      tableType === 2 && screenWidth > 815
        ? [
            {
              title: "Date / Ora",
              dataIndex: "date",
              key: "date",
              width: "15%",
              ellipsis: true,
              // sorter: (a, b) =>
              //   moment(a.date, "DD/MM/YYYY HH:mm").unix() -
              //   moment(b.date, "DD/MM/YYYY HH:mm").unix(),
            },
            {
              title: "Barcode",
              dataIndex: "barcode",
              key: "barcode",
              ...this.getColumnSearchProps("barcode"),
              width: "12%",
              ellipsis: true,
              onCell: (record) => {
                return {
                  onClick: (ev) => {
                    if (accountInfo.profile.role.name !== "agent") {
                      getCodiceTicket(record.barcode, record.service)
                      this.showModal(
                        this.state.index,
                        modalDetails.barcode,
                        modalDetails.agency_name,
                        modalDetails.agency_address,
                        modalDetails.agency_phone,
                      )
                    }
                  },
                }
              },
            },
            {
              title: "Utente",
              dataIndex: "ragione",
              key: "ragione",
              ...this.getColumnSearchProps("ragione"),
              width: "15%",
              ellipsis: true,
            },
            {
              title: "Service",
              dataIndex: "service",
              key: "service",
              ...this.getColumnSearchProps("service"),
              width: "15%",
              ellipsis: true,
              onCell: (record) => {
                return {
                  onClick: (ev) => {
                    if (accountInfo.profile.role.name !== "agent") {
                      getCodiceTicket(record.barcode, record.service)
                      this.showModal(
                        this.state.index,
                        modalDetails.barcode,
                        modalDetails.agency_name,
                        modalDetails.agency_address,
                        modalDetails.agency_phone,
                      )
                    }
                  },
                }
              },
            },
            {
              title: "Importo",
              dataIndex: "importo",
              key: "importo",
              align: "right",
              // sorter: (a, b) =>
              //   parseFloat(a.importo.replace(".", "")) -
              //   parseFloat(b.importo.replace(".", "")),
              width: "12%",
              render: (text, record) => (
                <span
                  style={{
                    padding: 0,
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{
                      width: "15px",
                      height: "15px",
                      padding: "8px",
                      border: `1.5px solid ${
                        record.sign === "+"
                          ? "green"
                          : record.sign === "-"
                            ? "red"
                            : "#ccc"
                      }`,
                      borderRadius: "50%",
                      fontWeight: "bold",
                      color:
                        record.sign === "+"
                          ? "green"
                          : record.sign === "-"
                            ? "red"
                            : "black",
                      fontSize: "14px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      lineHeight: 1,
                      textAlign: "center",
                      marginRight: "8px",
                    }}
                  >
                    {record.sign}
                  </div>
                  {text}
                  {record.paid_with_adyen ? (
                    <i
                      className="fa-solid fa-credit-card"
                      style={{
                        fontSize: 18,
                        color: "rgb(96 165 250)",
                        borderBottom: "none",
                      }}
                    ></i>
                  ) : (
                    <i
                      className="fa-solid fa-money-bill-wave"
                      style={{ fontSize: 18, color: "green", borderBottom: "none" }}
                    ></i>
                  )}
                </span>
              ),
            },
            {
              title: "Saldo",
              dataIndex: "saldo",
              key: "saldo",
              align: "right",
              // sorter: (a, b) =>
              //   parseFloat(a.saldo.replace(".", "")) -
              //   parseFloat(b.saldo.replace(".", "")),
              width: "10%",
            },
          ]
        : screenWidth > 815 && accountInfo.profile.role.name === "main_admin"
          ? [
              movimentiVisibleColumns["Date / Ora"] && {
                title: "Date / Ora",
                dataIndex: "date",
                key: "date",
                width: "10%",
                ellipsis: true,
                // sorter: (a, b) =>
                //   moment(a.date, "DD/MM/YYYY HH:mm").unix() -
                //   moment(b.date, "DD/MM/YYYY HH:mm").unix(),
              },
              movimentiVisibleColumns.Barcode && {
                title: "Barcode",
                dataIndex: "barcode",
                key: "barcode",
                ...this.getColumnSearchProps("barcode"),
                width: "10%",
                ellipsis: true,
                onCell: (record, rowIndex) => {
                  return {
                    onClick: (ev) => {
                      if (accountInfo.profile.role.name !== "agent") {
                        getCodiceTicket(record.barcode, record.service)
                        this.showModal(
                          this.state.index,
                          modalDetails.barcode,
                          modalDetails.agency_name,
                          modalDetails.agency_address,
                          modalDetails.agency_phone,
                        )
                      }
                    },
                  }
                },
              },
              movimentiVisibleColumns.Utente && {
                title: "Utente",
                dataIndex: "utente",
                ...this.getColumnSearchProps("utente"),
                ellipsis: true,
                width: "10%",
                onCell: (record) => {
                  return {
                    onClick: (ev) => {
                      const isCard =
                        this.state.paymentMethod === "card"
                          ? true
                          : this.state.paymentMethod === "wallet"
                            ? false
                            : null

                      this.setState({ username: record.username })
                      this.props.getPayments(
                        record.username,
                        from || today,
                        to || today,
                        1,
                        perPage,
                        this.props.activeSkinId === -1
                          ? null
                          : this.props.activeSkinId,
                        "",
                        service == "TUTTI" ? "" : service,
                        null,
                        activeCategory !== "TUTTI" ? activeCategory : null,
                        null,
                        this.state.provider ? this.state.provider : "",
                        activeSkinId === -1 ? true : undefined,
                        isCard,
                      )
                      record.utente?.props?.Word?.props &&
                        navigator.clipboard.writeText(record.username)

                      // notification["success"]({
                      //   message: "Il utente è stato copiato con successo",
                      //   placement: "topRight",
                      // })
                    },
                  }
                },
              },
              // {
              //   title: "Ragione Sociale",
              //   dataIndex: "ragione",
              //   key: "ragione",
              //   ...this.getColumnSearchProps("ragione"),
              //   width: "18%",
              //   ellipsis: true,
              // },
              movimentiVisibleColumns.Provider && {
                title: "Provider",
                dataIndex: "provider_name",
                key: "provider",
                ...this.getColumnSearchProps("provider_name"),
                width: "8%",
                ellipsis: true,
                align: "center",

                render: (text, record) => {
                  const exactLogo = `${baseUrlImg}/icon/${record?.provider_name}-icon.svg`
                  const lowerIcon = `${baseUrlImg}/icon/${record?.provider_name?.toLowerCase()}-icon.svg`

                  return record.provider_name ? (
                    <Tooltip title={text}>
                      <div style={{ padding: 0 }}>
                        <img
                          src={exactLogo}
                          style={{
                            width: "28px",
                            height: "28px",
                            padding: 0,
                            marginRight: "5px",
                          }}
                          onError={(e) => {
                            const img = e.currentTarget
                            if (img.src !== lowerIcon) {
                              img.src = lowerIcon
                            } else {
                              img.src = `${baseUrlImg}/icon/default-icon.svg`
                            }
                          }}
                        />
                      </div>
                    </Tooltip>
                  ) : (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        marginRight: "5px",
                      }}
                    >
                      <div
                        style={{
                          width: "24px",
                          height: "24px",
                          border: `2px solid ${
                            record.sign === "+"
                              ? "green"
                              : record.sign === "-"
                                ? "red"
                                : "#ccc"
                          }`,
                          borderRadius: "50%",
                          fontWeight: "bold",
                          color:
                            record.sign === "+"
                              ? "green"
                              : record.sign === "-"
                                ? "red"
                                : "black",
                          fontSize: "16px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          lineHeight: 1,
                          textAlign: "center",
                        }}
                      >
                        {record.sign}
                      </div>
                    </div>
                  )
                },
              },
              movimentiVisibleColumns.Brand && {
                title: "Brand",
                dataIndex: "company_name",
                key: "company_name",
                width: "12%",
                ellipsis: true,
              },
              movimentiVisibleColumns.Service && {
                title: "Service",
                dataIndex: "service",
                key: "service",
                ...this.getColumnSearchProps("service"),
                width: "10%",
                ellipsis: true,
                render: (text) => <span style={{ color: "#0078ff" }}>{text}</span>,
                onCell: (record) => {
                  return {
                    onClick: (ev) => {
                      if (accountInfo.profile.role.name !== "agent") {
                        getCodiceTicket(record.barcode, record.service)
                        this.showModal(
                          this.state.index,
                          modalDetails.barcode,
                          modalDetails.agency_name,
                          modalDetails.agency_address,
                          modalDetails.agency_phone,
                        )
                      }
                    },
                  }
                },
              },
              movimentiVisibleColumns.Category && {
                title: "Category",
                dataIndex: "category",
                key: "category",
                width: "8%",
                ellipsis: true,
              },
              movimentiVisibleColumns?.Utile?.Importo && {
                title: "Importo",
                dataIndex: "importo",
                key: "importo",
                align: "right",
                width: "14%",
                ellipsis: true,

                filters: [
                  { text: "Card", value: "card" },
                  { text: "Wallet", value: "wallet" },
                ],
                filteredValue: this.state.paymentMethod
                  ? [this.state.paymentMethod]
                  : null,

                render: (text, record) =>
                  record.type !== "adyen" ? (
                    <span
                      style={{
                        padding: 0,
                        display: "flex",
                        justifyContent: "flex-end",
                        alignItems: "center",
                      }}
                    >
                      <div
                        style={{
                          width: "15px",
                          height: "15px",
                          padding: "8px",
                          border: `1.5px solid ${
                            record.sign === "+"
                              ? "green"
                              : record.sign === "-"
                                ? "red"
                                : "#ccc"
                          }`,
                          borderRadius: "50%",
                          fontWeight: "bold",
                          color:
                            record.sign === "+"
                              ? "green"
                              : record.sign === "-"
                                ? "red"
                                : "black",
                          fontSize: "14px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          lineHeight: 1,
                          textAlign: "center",
                          marginRight: "8px",
                        }}
                      >
                        {record.sign}
                      </div>
                      {text}

                      {record.paid_with_adyen ? (
                        <i
                          className="fa-solid fa-credit-card"
                          style={{ fontSize: 18, color: "rgb(96 165 250)" }}
                        />
                      ) : (
                        <i
                          className="fa-solid fa-money-bill-wave"
                          style={{ fontSize: 18, color: "green" }}
                        />
                      )}
                    </span>
                  ) : (
                    <span>-</span>
                  ),
              },
              movimentiVisibleColumns?.Utile?.Commissione && {
                title: <span title="Commissione">Commissione</span>,
                dataIndex: "commissione",
                key: "commissione",
                align: "right",
                // sorter: (a, b) =>
                //   parseFloat(a.commissione.replace(".", "")) -
                //   parseFloat(b.commissione.replace(".", "")),
                width: "12%",
                ellipsis: true,
                render: (text, record) =>
                  record.type !== "adyen" ? (
                    <span>{text}</span>
                  ) : (
                    <span
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        lineHeight: "12px",
                      }}
                    >
                      <span>{text}</span>
                      <span style={{ color: "unset", textDecoration: "unset" }}>
                        (Imp. {record.importo})
                      </span>
                    </span>
                  ),
              },

              movimentiVisibleColumns?.Utile?.Provvigione && {
                title: <span title="Provvigione">Provvigione</span>,
                dataIndex: "proviggione",
                key: "proviggione",
                align: "right",
                // sorter: (a, b) =>
                //   parseFloat(a.proviggione.replace(",", ".")) -
                //   parseFloat(b.proviggione.replace(",", ".")),
                width: "7%",
                ellipsis: true,
              },
              movimentiVisibleColumns?.Utile?.Agente && {
                title: "Agente",
                dataIndex: "agent_profit",
                key: "agent_profit",
                align: "right",

                // sorter: (a, b) =>
                //   parseFloat(a.aggio.replace(",", ".")) -
                //   parseFloat(b.aggio.replace(",", ".")),
                width: "7%",
                ellipsis: true,
                render: (text) => {
                  return text === "NaN€" ? "-" : `${text}`
                },
              },
              movimentiVisibleColumns?.Utile?.Skin && {
                title: "Skin",
                dataIndex: "skin_profit",
                key: "skin_profit",
                align: "right",

                // sorter: (a, b) =>
                //   parseFloat(a.aggio.replace(",", ".")) -
                //   parseFloat(b.aggio.replace(",", ".")),
                width: "7%",
                ellipsis: true,
                render: (text) => {
                  return text === "NaN€" ? "-" : `${text}`
                },
              },
              movimentiVisibleColumns?.Utile?.Sistema && {
                title: "Sistema",
                dataIndex: "system_aggio",
                key: "system_aggio",
                align: "right",

                // sorter: (a, b) =>
                //   parseFloat(a.aggio.replace(",", ".")) -
                //   parseFloat(b.aggio.replace(",", ".")),
                width: "7%",
                ellipsis: true,
                render: (text) => {
                  return text === "NaN€" ? "-" : `${text}`
                },
              },
              // {
              //   title: "Aggio Provider",
              //   dataIndex: "aggio",
              //   key: "aggio_provider",
              //   // sorter: (a, b) =>
              //   //   parseFloat(a.aggio.replace(",", ".")) -
              //   //   parseFloat(b.aggio.replace(",", ".")),
              //   width: "9%",
              //   ellipsis: true,
              // },
              movimentiVisibleColumns.Saldo && {
                title: "Saldo",
                dataIndex: "saldo",
                key: "saldo",
                align: "right",

                // sorter: (a, b) =>
                //   parseFloat(a.saldo.replace(".", "")) -
                //   parseFloat(b.saldo.replace(".", "")),
                width: "7%",
                ellipsis: true,
              },
              movimentiVisibleColumns.Adyen && {
                title: "Paid with Adyen",
                dataIndex: "paid_with_adyen",
                key: "paid_with_adyen",
                align: "center",
                width: "7%",
                ellipsis: true,
                render: (text) => {
                  return <span>{text === 1 ? "True" : "False"}</span>
                },
              },
              // movimentiVisibleColumns.Refund && {
              //   title: "Refund",
              //   dataIndex: "refund",
              //   key: "refund",
              //   align: "center",
              //   ellipsis: true,
              //   width: "10%",
              //   render: (text, record) => {
              //     return record.paid_with_adyen && record.type !== "adyen" ? (
              //       <Button
              //         type="primary"
              //         size="small"
              //         style={{
              //           fontSize: 11,
              //         }}
              //         onClick={() => {
              //           Modal.confirm({
              //             title: "Conferma rimborso",
              //             content: `Vuoi effettuare il rimborso per il codice ${record.barcode}?`,
              //             okText: "Sì, rimborsa",
              //             cancelText: "Annulla",
              //             okButtonProps: { danger: true },
              //             onOk: async () => {
              //               try {
              //                 await this.props.refund(record.barcode)
              //               } catch (error) {
              //                 console.error("Refund failed:", error)
              //                 throw error
              //               }
              //             },
              //           })
              //         }}
              //       >
              //         REFUND
              //       </Button>
              //     ) : (
              //       <div>-</div>
              //     )
              //   },
              // },
              movimentiVisibleColumns.Cancella && {
                title: "Cancella",
                dataIndex: "cancella",
                key: "cancella",
                align: "center",
                ellipsis: true,
                width: "10%",
                render: (text, record) => {
                  if (record.payment_is_cancelled) {
                    return (
                      <Button
                        type="default"
                        disabled
                        size="small"
                        style={{
                          fontSize: 11,
                          padding: 0,
                          cursor: "not-allowed",
                        }}
                      >
                        Cancellato
                      </Button>
                    )
                  }

                  return (
                    <Tag
                      color="red"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        this.setState({
                          cancelModalOpen: true,
                          selectedRecord: record,
                        })
                      }}
                    >
                      Cancella
                    </Tag>
                  )
                },
              },
            ].filter(Boolean)
          : accountInfo.profile.role.name !== "main_admin" && screenWidth > 815
            ? [
                movimentiVisibleColumns["Date / Ora"] && {
                  title: "Date / Ora",
                  dataIndex: "date",
                  key: "date",
                  width: "10%",
                  ellipsis: true,
                  // sorter: (a, b) =>
                  //   moment(a.date, "DD/MM/YYYY HH:mm").unix() -
                  //   moment(b.date, "DD/MM/YYYY HH:mm").unix(),
                },
                movimentiVisibleColumns["Barcode"] && {
                  title: "Barcode",
                  dataIndex: "barcode",
                  key: "barcode",
                  ...this.getColumnSearchProps("barcode"),
                  width: "10%",
                  ellipsis: true,
                  onCell: (record, rowIndex) => {
                    return {
                      onClick: (ev) => {
                        if (accountInfo.profile.role.name !== "agent") {
                          getCodiceTicket(record.barcode, record.service)
                          this.showModal(
                            this.state.index,
                            modalDetails.barcode,
                            modalDetails.agency_name,
                            modalDetails.agency_address,
                            modalDetails.agency_phone,
                          )
                        }
                      },
                    }
                  },
                },
                movimentiVisibleColumns["Utente"] && {
                  title: "Utente",
                  dataIndex: "utente",
                  ...this.getColumnSearchProps("utente"),
                  ellipsis: true,
                  width: "12%",
                  onCell: (record) => {
                    return {
                      onClick: (ev) => {
                        const isCard =
                          this.state.paymentMethod === "card"
                            ? true
                            : this.state.paymentMethod === "wallet"
                              ? false
                              : null

                        this.setState({ username: record.username })
                        this.props.getPayments(
                          record.username,
                          from || today,
                          to || today,
                          1,
                          perPage,
                          this.props.activeSkinId === -1
                            ? null
                            : this.props.activeSkinId,
                          "",
                          service == "TUTTI" ? "" : service,
                          null,
                          activeCategory !== "TUTTI" ? activeCategory : null,
                          null,
                          this.state.provider ? this.state.provider : "",
                          this.props.activeSkinId === -1 ? true : null,
                          isCard,
                        )
                        navigator.clipboard.writeText(record.username)
                        // notification["success"]({
                        //   message: "Il utente è stato copiato con successo",
                        //   placement: "topRight",
                        // })
                      },
                    }
                  },
                },
                movimentiVisibleColumns.Provider && {
                  title: "Provider",
                  dataIndex: "provider_name",
                  key: "provider",
                  ...this.getColumnSearchProps("provider_name"),
                  width: "8%",
                  ellipsis: true,
                  align: "center",

                  render: (text, record) => {
                    const exactLogo = `${baseUrlImg}/icon/${record?.provider_name}-icon.svg`
                    const lowerIcon = `${baseUrlImg}/icon/${record?.provider_name?.toLowerCase()}-icon.svg`

                    return record.provider_name ? (
                      <Tooltip title={text}>
                        <div style={{ padding: 0 }}>
                          <img
                            src={exactLogo}
                            style={{
                              width: "28px",
                              height: "28px",
                              padding: 0,
                              marginRight: "5px",
                            }}
                            onError={(e) => {
                              const img = e.currentTarget
                              if (img.src !== lowerIcon) {
                                img.src = lowerIcon
                              } else {
                                img.src = `${baseUrlImg}/icon/default-icon.svg`
                              }
                            }}
                          />
                        </div>
                      </Tooltip>
                    ) : (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          marginRight: "5px",
                        }}
                      >
                        <div
                          style={{
                            width: "24px",
                            height: "24px",
                            border: `2px solid ${
                              record.sign === "+"
                                ? "green"
                                : record.sign === "-"
                                  ? "red"
                                  : "#ccc"
                            }`,
                            borderRadius: "50%",
                            fontWeight: "bold",
                            color:
                              record.sign === "+"
                                ? "green"
                                : record.sign === "-"
                                  ? "red"
                                  : "black",
                            fontSize: "16px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            lineHeight: 1,
                            textAlign: "center",
                          }}
                        >
                          {record.sign}
                        </div>
                      </div>
                    )
                  },
                },
                movimentiVisibleColumns.Brand && {
                  title: "Brand",
                  dataIndex: "company_name",
                  key: "company_name",
                  width: "12%",
                  ellipsis: true,
                },
                // {
                //   title: "Ragione Sociale",
                //   dataIndex: "ragione",
                //   key: "ragione",
                //   ...this.getColumnSearchProps("ragione"),
                //   width: "16%",
                //   ellipsis: true,
                // },
                movimentiVisibleColumns["Service"] && {
                  title: "Service",
                  dataIndex: "service",
                  key: "service",
                  ...this.getColumnSearchProps("service"),
                  width: "12%",
                  ellipsis: true,
                  render: (text) => <span style={{ color: "#0078ff" }}>{text}</span>,
                  onCell: (record) => {
                    return {
                      onClick: (ev) => {
                        if (accountInfo.profile.role.name !== "agent") {
                          getCodiceTicket(record.barcode, record.service)
                          this.showModal(
                            this.state.index,
                            modalDetails.barcode,
                            modalDetails.agency_name,
                            modalDetails.agency_address,
                            modalDetails.agency_phone,
                          )
                        }
                      },
                    }
                  },
                },
                movimentiVisibleColumns.Category && {
                  title: "Category",
                  dataIndex: "category",
                  key: "category",
                  width: "8%",
                  ellipsis: true,
                },
                movimentiVisibleColumns?.Utile["Importo"] && {
                  title: "Importo",
                  dataIndex: "importo",
                  key: "importo",
                  align: "right",
                  // sorter: (a, b) => parseFloat(a.importo) - parseFloat(b.importo),
                  width: "10%",
                  ellipsis: true,
                  render: (text, record) =>
                    record.type !== "adyen" ? (
                      <span
                        style={{
                          padding: 0,
                          display: "flex",
                          justifyContent: "flex-end",
                          alignItems: "center",
                        }}
                      >
                        <div
                          style={{
                            width: "15px",
                            height: "15px",
                            padding: "8px",
                            border: `1.5px solid ${
                              record.sign === "+"
                                ? "green"
                                : record.sign === "-"
                                  ? "red"
                                  : "#ccc"
                            }`,
                            borderRadius: "50%",
                            fontWeight: "bold",
                            color:
                              record.sign === "+"
                                ? "green"
                                : record.sign === "-"
                                  ? "red"
                                  : "black",
                            fontSize: "14px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            lineHeight: 1,
                            textAlign: "center",
                            marginRight: "8px",
                          }}
                        >
                          {record.sign}
                        </div>
                        {text}
                        {record.paid_with_adyen ? (
                          <i
                            className="fa-solid fa-credit-card"
                            style={{ fontSize: 18, color: "rgb(96 165 250)" }}
                          ></i>
                        ) : (
                          <i
                            className="fa-solid fa-money-bill-wave"
                            style={{ fontSize: 18, color: "green" }}
                          ></i>
                        )}
                      </span>
                    ) : (
                      <span>-</span>
                    ),
                },
                movimentiVisibleColumns?.Utile["Commissione"] && {
                  title: <span title="Commissione">Commissione</span>,
                  dataIndex: "commissione",
                  key: "commissione",
                  align: "right",
                  // sorter: (a, b) =>
                  //   parseFloat(a.commissione.replace(".", "")) -
                  //   parseFloat(b.commissione.replace(".", "")),
                  width: "8%",
                  ellipsis: true,

                  render: (text, record) =>
                    record.type !== "adyen" ? (
                      <span>{text}</span>
                    ) : (
                      <span
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "center",
                          lineHeight: "12px",
                        }}
                      >
                        <span>{text}</span>
                        <span style={{ color: "unset", textDecoration: "unset" }}>
                          (Imp. {record.importo})
                        </span>
                      </span>
                    ),
                },
                movimentiVisibleColumns?.Utile["Provvigione"] && {
                  title: <span title="Provvigione">Provvigione</span>,
                  dataIndex: "proviggione",
                  key: "proviggione",
                  align: "right",
                  // sorter: (a, b) =>
                  //   parseFloat(a.proviggione.replace(",", ".")) -
                  //   parseFloat(b.proviggione.replace(",", ".")),
                  width: "8%",
                  ellipsis: true,
                },
                movimentiVisibleColumns?.Utile?.Agente && {
                  title: "Agente",
                  dataIndex: "agent_profit",
                  key: "agent_profit",
                  align: "right",
                  // sorter: (a, b) =>
                  //   parseFloat(a.aggio.replace(",", ".")) -
                  //   parseFloat(b.aggio.replace(",", ".")),
                  width: "8%",
                  ellipsis: true,
                  render: (text) => {
                    return text === "NaN€" ? "-" : `${text}`
                  },
                },
                movimentiVisibleColumns?.Utile?.Skin &&
                  accountInfo.profile.role.name !== "agent" && {
                    title: "Skin",
                    dataIndex: "skin_profit",
                    key: "skin_profit",
                    align: "right",

                    // sorter: (a, b) =>
                    //   parseFloat(a.aggio.replace(",", ".")) -
                    //   parseFloat(b.aggio.replace(",", ".")),
                    width: "8%",
                    ellipsis: true,
                    render: (text) => {
                      return text === "NaN€" ? "-" : `${text}`
                    },
                  },
                {
                  title: "Saldo",
                  dataIndex: "saldo",
                  key: "saldo",
                  align: "right",
                  // sorter: (a, b) =>
                  //   parseFloat(a.saldo.replace(".", "")) -
                  //   parseFloat(b.saldo.replace(".", "")),
                  width: "8%",
                  ellipsis: true,
                },
                movimentiVisibleColumns["Check Crypto"] &&
                  accountInfo.profile.role.name !== "agent" && {
                    title: "Check Crypto",
                    dataIndex: "check_crypto",
                    key: "check_crypto",
                    width: "10%",
                    align: "center",
                    className: "check-crypto",
                    ellipsis: true,
                    render: (text, record) => {
                      return record.service_type === "K" ? (
                        <Button
                          style={{ borderRadius: "16px" }}
                          onClick={() => checkCrypto(record.barcode, record.service)}
                        >
                          Autorizza
                        </Button>
                      ) : null
                    },
                  },
              ].filter(Boolean)
            : screenWidth > 300 && screenWidth < 815 && tableType !== 2
              ? [
                  {
                    title: "Date / Barcode",
                    dataIndex: "date",
                    ellipsis: true,
                    render: (text, record) => (
                      <div className="data-barcode-row">
                        <span>{text}</span>
                        <span>{record.barcode}</span>
                      </div>
                    ),
                    width: "28%",
                    onCell: (record) => {
                      return {
                        onClick: (ev) => {
                          if (accountInfo.profile.role.name !== "agent") {
                            getCodiceTicket(record.barcode, record.service)
                            this.showModal(
                              this.state.index,
                              modalDetails.barcode,
                              modalDetails.agency_name,
                              modalDetails.agency_address,
                              modalDetails.agency_phone,
                            )
                          }
                        },
                      }
                    },
                  },
                  {
                    title: "Utente",
                    dataIndex: "utente",
                    key: "utente",
                    ...this.getColumnSearchProps("utente"),
                    ellipsis: true,
                    width: "25%",
                    onCell: (record) => {
                      return {
                        onClick: (ev) => {
                          const isCard =
                            this.state.paymentMethod === "card"
                              ? true
                              : this.state.paymentMethod === "wallet"
                                ? false
                                : null

                          this.setState({ username: record.username })
                          this.props.getPayments(
                            record.username,
                            from || today,
                            to || today,
                            1,
                            perPage,
                            this.props.activeSkinId === -1
                              ? null
                              : this.props.activeSkinId,
                            "",
                            service == "TUTTI" ? "" : service,
                            null,
                            activeCategory !== "TUTTI" ? activeCategory : null,
                            null,
                            this.state.provider ? this.state.provider : "",
                            this.props.activeSkinId === -1 ? true : null,
                            isCard,
                          )
                          navigator.clipboard.writeText(record.username)
                          // notification["success"]({
                          //   message: "Il utente è stato copiato con successo",
                          //   placement: "topRight",
                          // })
                        },
                      }
                    },
                  },
                  // {
                  //   title: "Ragione Sociale",
                  //   dataIndex: "ragione",
                  //   key: "ragione",
                  //   ...this.getColumnSearchProps("ragione"),
                  //   width: "25%",
                  //   ellipsis: true,
                  // },
                  {
                    title: "Service",
                    dataIndex: "service",
                    key: "service",
                    ...this.getColumnSearchProps("service"),
                    width: "18%",
                    ellipsis: true,
                    onCell: (record) => {
                      return {
                        onClick: (ev) => {
                          if (accountInfo.profile.role.name !== "agent") {
                            getCodiceTicket(record.barcode, record.service)
                            this.showModal(
                              this.state.index,
                              modalDetails.barcode,
                              modalDetails.agency_name,
                              modalDetails.agency_address,
                              modalDetails.agency_phone,
                            )
                          }
                        },
                      }
                    },
                  },
                  // {
                  //   title: "Importo",
                  //   dataIndex: "importo",
                  //   key: "importo",
                  //   // sorter: (a, b) => parseFloat(a.importo) - parseFloat(b.importo),
                  //   width: "13%",
                  //   ellipsis: true,
                  // },
                  {
                    title: "Dett.",
                    dataIndex: "details",
                    key: "details",
                    width: "11%",
                    onCell: (record) => {
                      return {
                        onClick: (ev) => {
                          this.setState({
                            showModalResponsive: true,
                            modalDetails: record,
                          })
                        },
                      }
                    },
                  },
                ]
              : screenWidth < 815 && tableType === 2
                ? [
                    {
                      title: "Ragione Sociale",
                      dataIndex: "ragione",
                      ...this.getColumnSearchProps("ragione"),
                      ellipsis: true,
                      width: "35%",
                    },
                    // {
                    //   title: "Service",
                    //   dataIndex: "service",
                    //   key: "service",
                    //   ...this.getColumnSearchProps("service"),
                    //   width: "35%",
                    //   ellipsis: true,
                    //   onCell: (record) => {
                    //     return {
                    //       onClick: (ev) => {
                    //         if (accountInfo.profile.role.name !== "agent") {
                    //           getCodiceTicket(record.barcode, record.service)
                    //           this.showModal(
                    //             this.state.index,
                    //             modalDetails.barcode,
                    //             modalDetails.agency_name,
                    //             modalDetails.agency_address,
                    //             modalDetails.agency_phone,
                    //           )
                    //         }
                    //       },
                    //     }
                    //   },
                    // },
                    {
                      title: "Importo",
                      dataIndex: "importo",
                      key: "importo",
                      // sorter: (a, b) => parseFloat(a.importo) - parseFloat(b.importo),
                      width: "25%",
                      ellipsis: true,
                      render: (text, record) => (
                        <span
                          style={{
                            padding: 0,
                            display: "flex",
                            justifyContent: "flex-end",
                            alignItems: "center",
                          }}
                        >
                          <div
                            style={{
                              width: "15px",
                              height: "15px",
                              padding: "8px",
                              border: `1.5px solid ${
                                record.sign === "+"
                                  ? "green"
                                  : record.sign === "-"
                                    ? "red"
                                    : "#ccc"
                              }`,
                              borderRadius: "50%",
                              fontWeight: "bold",
                              color:
                                record.sign === "+"
                                  ? "green"
                                  : record.sign === "-"
                                    ? "red"
                                    : "black",
                              fontSize: "14px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              lineHeight: 1,
                              textAlign: "center",
                              marginRight: "8px",
                            }}
                          >
                            {record.sign}
                          </div>
                          {text}
                          {record.paid_with_adyen ? (
                            <i
                              className="fa-solid fa-credit-card"
                              style={{ fontSize: 18, color: "rgb(96 165 250)" }}
                            ></i>
                          ) : (
                            <i
                              className="fa-solid fa-money-bill-wave"
                              style={{ fontSize: 18, color: "green" }}
                            ></i>
                          )}
                        </span>
                      ),
                    },
                    {
                      title: "Dett.",
                      dataIndex: "details",
                      key: "details",
                      width: "15%",
                      ellipsis: true,
                      onCell: (record) => {
                        return {
                          onClick: (ev) => {
                            this.setState({
                              showModalResponsive: true,
                              modalDetails: record,
                            })
                          },
                        }
                      },
                    },
                  ]
                : [
                    {
                      title: "Date / Barcode",
                      dataIndex: "date",
                      ellipsis: true,
                      render: (text, record) => (
                        <div className="data-barcode-row">
                          <span>{text}</span>
                          <span>{record.barcode}</span>
                        </div>
                      ),
                      width: "35%",
                      onCell: (record) => {
                        return {
                          onClick: (ev) => {
                            if (accountInfo.profile.role.name !== "agent") {
                              getCodiceTicket(record.barcode, record.service)
                              this.showModal(
                                this.state.index,
                                modalDetails.barcode,
                                modalDetails.agency_name,
                                modalDetails.agency_address,
                                modalDetails.agency_phone,
                              )
                            }
                          },
                        }
                      },
                    },
                    {
                      title: "Utente",
                      dataIndex: "utente",
                      ...this.getColumnSearchProps("utente"),
                      ellipsis: true,
                      width: "30%",
                      onCell: (record) => {
                        return {
                          onClick: (ev) => {
                            const isCard =
                              this.state.paymentMethod === "card"
                                ? true
                                : this.state.paymentMethod === "wallet"
                                  ? false
                                  : null

                            this.setState({
                              username: record.utente.props.Word.props.Word,
                            })
                            this.props.getPayments(
                              record.utente.props.Word.props.Word,
                              from || today,
                              to || today,
                              1,
                              perPage,
                              this.props.activeSkinId === -1
                                ? null
                                : this.props.activeSkinId,
                              "",
                              service == "TUTTI" ? "" : service,
                              null,
                              activeCategory !== "TUTTI" ? activeCategory : null,
                              null,
                              this.state.provider ? this.state.provider : "",
                              this.props.activeSkinId === -1 ? true : null,
                              isCard,
                            )
                          },
                        }
                      },
                    },
                    {
                      title: "Service",
                      dataIndex: "service",
                      key: "service",
                      ...this.getColumnSearchProps("service"),
                      width: "25%",
                      onCell: (record) => {
                        return {
                          onClick: (ev) => {
                            if (accountInfo.profile.role.name !== "agent") {
                              getCodiceTicket(record.barcode, record.service)
                              this.showModal(
                                this.state.index,
                                modalDetails.barcode,
                                modalDetails.agency_name,
                                modalDetails.agency_address,
                                modalDetails.agency_phone,
                              )
                            }
                          },
                        }
                      },
                      ellipsis: true,
                    },
                    // {
                    //   title: "Importo",
                    //   dataIndex: "importo",
                    //   key: "importo",
                    //   // sorter: (a, b) => parseFloat(a.importo) - parseFloat(b.importo),
                    //   width: "20%",
                    //   ellipsis: true,
                    // },
                    {
                      title: "Dett.",
                      dataIndex: "details",
                      key: "details",
                      width: "15%",
                      ellipsis: true,
                      onCell: (record) => {
                        return {
                          onClick: (ev) => {
                            this.setState({
                              showModalResponsive: true,
                              modalDetails: record,
                            })
                          },
                        }
                      },
                    },
                  ]

    // if (accountInfo.profile.role === "agent") {
    //   columns = columns.filter(function (value, index, arr) {
    //     if (value.dataIndex !== "utente") {
    //       return value
    //     }
    //   })
    // }

    if (
      accountInfo.profile.role.name === "agent" ||
      accountInfo.profile.role.name === "super_admin"
    ) {
      const index = columns.findIndex((column) => column.key === "aggio_skin")
      if (index !== -1) {
        columns.splice(index, 1)
      }
    }

    var data =
      paymentsO &&
      isArray(paymentsO) &&
      paymentsO?.map((p) => ({
        date: moment(p.executed_date).format("DD/MM/YYYY HH:mm:ss"),
        barcode: p.barcode,
        utente: (
          <UtenteCell
            icon={p.user_role === "user" ? "fal fa-user-circle" : "fal fa-store"}
            Word={
              p.agency_username ? (
                <>
                  <span>{p.agency_username}</span>
                  <span>{p.agency_name}</span>
                </>
              ) : (
                username
              )
            }
            title={p.agency_name}
          />
        ),
        ragione:
          tableType === 2 ? (
            <UtenteCell
              icon={p.user_role === "user" ? "fal fa-user-circle" : "fal fa-store"}
              Word={p.agency_name}
              title={p.agency_name}
            />
          ) : (
            <SpanFormater
              myClassName="nomeTd"
              Word={p?.agency_name}
              size={35}
              nrOfRows={1}
              formatWord={true}
            />
          ),
        service: p.service_name,
        importo:
          numberWithCommas(
            tableType === 2 ? p.price1000 / 1000 : p.price1000 / 100,
          ) + "€",
        commissione: p.commissione + "€",
        proviggione:
          parseFloat((p.provvigione || "0").replace(",", ".")).toFixed(6) + "€",
        aggio: parseFloat(p.system_aggio).toFixed(6) + "€",
        system_aggio: parseFloat(p.system_aggio).toFixed(6) + "€",
        saldo: p.saldo + "€",
        user_role: p.user_role,
        details: <i className="fal fa-plus-square" />,
        image: p.logo,
        username: p.agency_username,
        provider_name: p.provider_name,
        company_name: p.company_name,
        category: p.category_name,
        skin_to_agency_ratio: p.skin_to_agency_ratio,
        agent_profit: parseFloat(p.agent_profit).toFixed(6) + "€",
        skin_profit: parseFloat(p.skin_profit).toFixed(6) + "€",
        paid_with_adyen: p.paid_with_adyen,
        service_type: p.service_type,
        type: p.type,
        payment_id: p.payment_id,
        payment_is_cancelled: p.payment_is_cancelled,
        sign: p.sign,
      }))

    return (
      <>
        <div className="Container Annunci Movimenti" style={{ width: "100%" }}>
          {cancelModalOpen && (
            <CancelServiceForm
              isVisible={cancelModalOpen}
              onClose={() => {
                this.setState({ cancelModalOpen: false })
              }}
              record={selectedRecord}
              handleSubmit={async (val) => {
                try {
                  console.log("FORM SUBMITTED VALUES:", val)

                  await this.props.cancel(
                    selectedRecord.payment_id,
                    val.nome_operatore,
                    val.description,
                  )

                  await this.props.getPayments(
                    username ? username : "",
                    from || today,
                    to || today,
                    1,
                    perPage,
                    this.props.activeSkinId === -1 ? null : this.props.activeSkinId,
                    "",
                    service === "TUTTI" ? "" : service,
                    null,
                    activeCategory !== "TUTTI" ? activeCategory : null,
                    null,
                    this.state.provider ? this.state.provider : "",
                    this.props.activeSkinId === -1 ? true : undefined,
                  )
                  this.setState({ cancelModalOpen: false, selectedRecord: null })
                } catch (error) {
                  console.error("CANCEL ERROR:", error)
                  notification["error"]({
                    message: "Errore durante la cancellazione. Riprova!",
                    placement: "topRight",
                  })
                }
              }}
            />
          )}

          {this.state.showModalResponsive === true &&
            this.props.screenWidth <= 1024 &&
            forAdmin && (
              <ModalResponsiveForTables
                Close={(e) => {
                  this.setState({
                    modalDetails: "",
                    showModalResponsive: false,
                  })
                }}
                Header={
                  <React.Fragment>
                    <i className="fal fa-user-alt" aria-hidden="true"></i>
                    <span>{modalDetails?.ragione?.props?.Word}</span>
                  </React.Fragment>
                }
                beforeFooter={null}
                Footer={null}
                Rows={
                  <React.Fragment>
                    <div className="ServiceRow">
                      <ModalRow
                        title="Service"
                        data={modalDetails.service}
                        image={<img src={`${baseUrlImg}/${modalDetails.image}`} />}
                      />
                    </div>
                    <div className="DateOraRow">
                      <ModalRow title="Date Ora" data={modalDetails.date} />
                    </div>
                    <div className="OtherRow">
                      <ModalRow title="Barcode" data={modalDetails?.barcode} />

                      <ModalRow
                        title="User"
                        data={modalDetails?.ragione?.props?.Word}
                      />
                      <ModalRow title="Importo" data={modalDetails.importo} />
                      <ModalRow
                        title="Commissione"
                        data={modalDetails.commissione}
                      />
                      <ModalRow
                        title="Proviggione"
                        data={modalDetails.proviggione}
                      />
                      <ModalRow title="Aggio" data={modalDetails?.aggio} />
                      <ModalRow
                        title="Agente"
                        data={modalDetails?.agent_profit}
                      />
                      <ModalRow
                        title="Skin"
                        data={modalDetails?.skin_profit}
                      />
                      <ModalRow title="Saldo" data={modalDetails.saldo} />
                    </div>
                  </React.Fragment>
                }
              />
            )}
          <div
            className="container-fluid overview"
            style={{
              paddingBottom: 50,
            }}
          >
            <div className="panels-container">
              {isCalendarOpen && (
                <CalendarRangePicker
                  setStateFunc={(item) => {
                    this.setState({
                      picker: [item.selection],
                      from: moment(item.selection.startDate).format("YYYY-MM-DD"),
                      to: moment(item.selection.endDate).format("YYYY-MM-DD"),
                      fromLabel: moment(item.selection.startDate).format(
                        "DD/MM/YYYY",
                      ),
                      toLabel: moment(item.selection.endDate).format("DD/MM/YYYY"),
                    })
                  }}
                  setStateFuncEmpty={() => {
                    this.setState({
                      from: "",
                      to: "",
                      fromLabel: "",
                      toLabel: "",
                    })
                  }}
                  picker={picker}
                  setCalendar={this.setCalendar}
                  handleSubmit={this.handleSubmit}
                />
              )}

              <>
                {/* <AdminNewStatistiche
                    importo={stat?.importo}
                    commissione={stat?.commissione}
                    provRete={stat?.proviggioni}
                    aggio={stat?.system_aggio}
                    onDateChange={this.handleDateChange}
                  /> */}
                <div className="movimenti-header-container">
                  <div className="left">
                    <h1
                      onClick={() => {
                        this.props.getPayments(
                          null,
                          today,
                          today,
                          1,
                          25,
                          activeSkinId === -1 ? null : activeSkinId,
                          null,
                          null,
                          null,
                          null,
                          null,
                          null,
                          activeSkinId === -1 ? true : undefined,
                        )

                        this.setState({
                          tableType: 1,
                          username: "",
                          service: "",
                          from: "",
                          fromLabel: moment(today).format("DD/MM/YYYY"),
                          toLabel: moment(today).format("DD/MM/YYYY"),
                          to: "",
                          activeCategory: "TUTTI",
                          provider: "",
                          paymentMethod: "",
                        })
                      }}
                    >
                      <Icon type="credit-card" />
                      Tutti Movimenti
                    </h1>
                    <div className="movimenti-filters">
                      <div
                        className="dal calendar"
                        type="text"
                        onClick={() => {
                          this.setCalendar(true)
                        }}
                      >
                        <i className="fal fa-calendar-alt"></i>
                        <span>
                          {fromLabel
                            ? `${fromLabel} - ${toLabel}`
                            : "Seleziona la data"}
                        </span>
                      </div>
                      {this.props.accountInfo.profile.role.name === "main_admin" && (
                        <button
                          className={
                            "filterBtn" + (tableType === 2 ? " active" : "")
                          }
                          htmltype="submit"
                          onClick={(e) => {
                            this.handleSubmit(e, true)
                          }}
                        >
                          <i className="fad fa-coins"></i>
                          ENTRATE
                        </button>
                      )}
                      <Pdf
                        paymentExcelLoading={this.props.paymentExcelLoading}
                        username={username}
                        from={from}
                        to={to}
                        service={service}
                        perPage={perPage}
                        payments={paymentsForExcel}
                        getPaymentsForExcel={this.props.getPaymentsForExcel}
                        provider_name={this.state.provider}
                        card={
                          this.state.paymentMethod === "card"
                            ? true
                            : this.state.paymentMethod === "wallet"
                              ? false
                              : null
                        }
                        activeSkinId={this.props.activeSkinId}
                      />
                      <Excel
                        username={username}
                        from={from}
                        to={to}
                        service={service}
                        perPage={perPage}
                        payments={paymentsForExcel}
                        allSkins={false}
                        provider_name={this.state.provider}
                        card={
                          this.state.paymentMethod === "card"
                            ? true
                            : this.state.paymentMethod === "wallet"
                              ? false
                              : null
                        }
                        activeSkinId={this.props.activeSkinId}
                      />
                      <TreeSelect
                        className="brand-selection"
                        showSearch
                        style={{ marginLeft: 10, width: 180, height: 37 }}
                        dropdownStyle={{ maxHeight: 400, overflow: "auto" }}
                        placeholder="Seleziona una categoria"
                        treeCheckable={true}
                        allowClear
                        onChange={(values) => {
                          const isCard =
                            this.state.paymentMethod === "card"
                              ? true
                              : this.state.paymentMethod === "wallet"
                                ? false
                                : null

                          this.props.getPayments(
                            username,
                            from,
                            to,
                            1,
                            perPage,
                            activeSkinId === -1 ? null : activeSkinId,
                            null,
                            service,
                            null,
                            values.length > 0 ? values : null,
                            null,
                            this.state.provider ? this.state.provider : "",
                            activeSkinId === -1 ? true : null,
                            isCard,
                          )
                        }}
                        treeData={[...this.transformToTreeData(servicesTree)]}
                        filterTreeNode={(inputValue, treeNode) => {
                          return treeNode.props.title
                            .toLowerCase()
                            .includes(inputValue.toLowerCase())
                        }}
                      />
                      <Select
                        className="brand-selection"
                        showSearch
                        allowClear
                        filterOption={false}
                        onSearch={(value) => {
                          this.setState({
                            serviceSearch: value,
                          })
                        }}
                        onChange={(value) => {
                          if (!value) {
                            this.setState({
                              selectedService: null,
                              service: "",
                            })

                            const isCard =
                              this.state.paymentMethod === "card"
                                ? true
                                : this.state.paymentMethod === "wallet"
                                  ? false
                                  : null

                            this.props.getPayments(
                              username,
                              from || today,
                              to || today,
                              1,
                              perPage,
                              activeSkinId === -1 ? null : activeSkinId,
                              null,
                              null,
                              null,
                              null,
                              null,
                              this.state.provider ? this.state.provider : "",
                              activeSkinId === -1 ? true : undefined,
                              isCard,
                            )
                          }
                        }}
                        onClear={() => {
                          this.setState({
                            selectedService: null,
                            service: "",
                          })

                          const isCard =
                            this.state.paymentMethod === "card"
                              ? true
                              : this.state.paymentMethod === "wallet"
                                ? false
                                : null

                          this.props.getPayments(
                            username,
                            from || today,
                            to || today,
                            1,
                            perPage,
                            activeSkinId === -1 ? null : activeSkinId,
                            null,
                            null,
                            null,
                            null,
                            null,
                            this.state.provider ? this.state.provider : "",

                            activeSkinId === -1 ? true : undefined,
                            isCard,
                          )
                        }}
                        style={{ marginLeft: 10, width: 220, height: 37 }}
                        placeholder="Cerca servizio"
                        dropdownStyle={{ maxHeight: 400, overflow: "auto" }}
                        value={this.state.selectedService?.name}
                        dropdownRender={() => (
                          <div>
                            {companies?.map((company) => (
                              <React.Fragment key={company.id}>
                                <div
                                  className="ant-select-dropdown-menu-item"
                                  onMouseDown={(e) => {
                                    e.preventDefault()

                                    const isSameCompany =
                                      this.state.selectedCompany?.id === company.id

                                    this.setState({
                                      selectedCompany: isSameCompany
                                        ? null
                                        : company,
                                      selectedService: null,
                                    })

                                    if (!isSameCompany) {
                                      this.props.getSelectedCompany(company.id)
                                    }
                                  }}
                                >
                                  {company.name}
                                </div>

                                {this.state.selectedCompany?.id === company.id &&
                                  this.props.selectedCompany?.services?.map(
                                    (service) => (
                                      <div
                                        key={service.id}
                                        className="ant-select-dropdown-menu-item"
                                        style={{
                                          paddingLeft: 32,
                                          backgroundColor:
                                            this.state.selectedService?.id ===
                                            service.id
                                              ? "#e6f7ff"
                                              : "#f5f5f5",
                                          fontWeight:
                                            this.state.selectedService?.id ===
                                            service.id
                                              ? 700
                                              : 400,
                                        }}
                                        onMouseDown={(e) => {
                                          e.preventDefault()

                                          const isCard =
                                            this.state.paymentMethod === "card"
                                              ? true
                                              : this.state.paymentMethod === "wallet"
                                                ? false
                                                : null

                                          this.setState({
                                            selectedService: service,
                                            service: service.name,
                                          })

                                          this.props.getPayments(
                                            username,
                                            from || today,
                                            to || today,
                                            1,
                                            perPage,
                                            activeSkinId === -1
                                              ? null
                                              : activeSkinId,
                                            "",
                                            service.name,
                                            null,
                                            null,
                                            null,
                                            this.state.provider
                                              ? this.state.provider
                                              : "",

                                            activeSkinId === -1 ? true : undefined,
                                            isCard,
                                          )
                                        }}
                                      >
                                        {service.name}
                                      </div>
                                    ),
                                  )}
                              </React.Fragment>
                            ))}
                          </div>
                        )}
                      />

                      {/* <Select
                        style={{ marginLeft: 20, width: 200 }}
                        placeholder="Seleziona una categoria"
                        onChange={(value) => {
                          this.setState({
                            activeCategory: value,
                          })
                          this.props.getPayments(
                            username,
                            from,
                            to,
                            1,
                            perPage,
                            activeSkinId,
                            null,
                            service,
                            null,
                            value
                          )
                        }}
                      >
                        <Option value="TUTTI">TUTTI</Option>
                        {allServices?.categories?.map((c) => (
                          <Option value={c.id} key={c.id}>
                            {c.name}
                          </Option>
                        ))}
                      </Select> */}
                    </div>
                  </div>
                  {screenWidth > 600 &&
                    (() => {
                      const role = this.props.accountInfo?.profile?.role?.name

                      const hiddenForAgent = [
                        "Skin",
                        "Sistema",
                        "Agent",
                        "Adyen",
                        "Refund",
                        "Cancella",
                        "Check Crypto",
                      ]

                      const hiddenForSkin = [
                        "Sistema",
                        "Adyen",
                        "Refund",
                        "Cancella",
                      ]

                      const hiddenForNonAdmin =
                        role === "agent" ? hiddenForAgent : hiddenForSkin

                      return (
                        <div>
                          <Button
                            style={{ height: 37, marginBottom: 4 }}
                            onClick={() => {
                              this.props.getPayments(
                                null,
                                today,
                                today,
                                1,
                                25,
                                activeSkinId === -1 ? null : activeSkinId,
                                null,
                                null,
                                null,
                                null,
                                null,
                                null,
                                activeSkinId === -1 ? true : undefined,
                              )

                              this.setState({
                                tableType: 1,
                                username: "",
                                service: "",
                                from: "",
                                fromLabel: "",
                                toLabel: "",
                                to: "",
                                activeCategory: "TUTTI",
                                provider: "",
                                paymentMethod: "",
                              })
                            }}
                          >
                            Cancella filtri
                          </Button>
                          <Popover
                            placement="bottom"
                            content={
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  gap: 5,
                                }}
                              >
                                {Object.keys(movimentiVisibleColumns)
                                  .filter((colKey) => {
                                    // Show all for main_admin
                                    if (role === "main_admin") return true
                                    // Hide columns in hiddenForNonAdmin
                                    return !hiddenForNonAdmin.includes(colKey)
                                  })
                                  .map((colKey) => (
                                    <div
                                      key={colKey}
                                      style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        gap: 5,
                                      }}
                                    >
                                      {typeof movimentiVisibleColumns[colKey] ===
                                      "object" ? (
                                        <>
                                          <Checkbox
                                            checked={Object.values(
                                              movimentiVisibleColumns[colKey],
                                            ).every(Boolean)}
                                            onChange={() =>
                                              this.handleCheckAll(colKey)
                                            }
                                          >
                                            {colKey}
                                          </Checkbox>

                                          {Object.keys(
                                            movimentiVisibleColumns[colKey],
                                          )
                                            .filter((subKey) => {
                                              if (
                                                role !== "main_admin" &&
                                                hiddenForNonAdmin.includes(subKey)
                                              ) {
                                                return false
                                              }
                                              return true
                                            })
                                            .map((subKey) => (
                                              <Checkbox
                                                key={subKey}
                                                checked={
                                                  movimentiVisibleColumns[colKey][
                                                    subKey
                                                  ]
                                                }
                                                onChange={(e) =>
                                                  this.handleCheckboxChange(
                                                    e,
                                                    colKey,
                                                    subKey,
                                                  )
                                                }
                                                style={{ marginLeft: 16 }}
                                              >
                                                {subKey}
                                              </Checkbox>
                                            ))}
                                        </>
                                      ) : (
                                        <Checkbox
                                          checked={movimentiVisibleColumns[colKey]}
                                          onChange={(e) =>
                                            this.handleCheckboxChange(e, colKey)
                                          }
                                        >
                                          {colKey}
                                        </Checkbox>
                                      )}
                                    </div>
                                  ))}
                              </div>
                            }
                            trigger="click"
                          >
                            <Button
                              style={{ height: 37, marginLeft: 10, marginBottom: 4 }}
                            >
                              Opzioni Tabela
                            </Button>
                          </Popover>
                        </div>
                      )
                    })()}
                </div>
                <SkinSelectRow
                  skinList={this.props.skinList}
                  activeSkinId={this.props.activeSkinId}
                  setActiveSkinId={this.props.setActiveSkinId}
                  setActiveSkinName={this.props.setActiveSkinName}
                />
              </>

              {/* {this.props.activeSkinId === -1 && (
                <div className="no-data">
                  {" "}
                  <i className="fal fa-info-circle"></i>
                  <span>No Data</span>
                </div>
              )} */}
              {!loadingPayments && screenWidth > 500 && (
                <Table
                  className="total-table"
                  columns={totalcolumns}
                  dataSource={totaldata}
                  pagination={false}
                />
              )}

              {loadingPayments &&
                (forAdmin ? <div className="loaderAdmin"></div> : <Loader />)}
              {!loadingPayments && (
                <Table
                  className={tableType === 2 ? "entrate" : ""}
                  rowClassName={(record) => {
                    if (record.payment_is_cancelled) return "data-row row-cancelled"
                    return record.user_role === "user" ? "data-row user" : "data-row"
                  }}
                  rowKey={(record) => record.barcode}
                  style={{ width: "100%", padding: "0 10px" }}
                  columns={columns}
                  pagination={false}
                  showHeader={true}
                  dataSource={data}
                  onChange={this.handleTableChange}
                />
              )}
            </div>
          </div>
        </div>
        {
          <div className="paginationWrapper">
            <Pagination
              onChange={(e) => {
                const isCard =
                  this.state.paymentMethod === "card"
                    ? true
                    : this.state.paymentMethod === "wallet"
                      ? false
                      : null

                if (tableType === 1) {
                  forAdmin
                    ? this.props.getPayments(
                        username !== "" ? username : "",
                        from || today,
                        to || today,
                        e,
                        perPage,
                        activeSkinId === -1 ? null : activeSkinId,
                        "",
                        service !== "" && service != "TUTTI" ? service : "",
                        null,
                        activeCategory !== "TUTTI" ? activeCategory : null,
                        null,
                        this.state.provider ? this.state.provider : "",
                        activeSkinId === -1 ? true : null,
                        isCard,
                      )
                    : getPayments(
                        username !== "" ? username : "",
                        from || today,
                        to || today,
                        e,
                        perPage,
                        "",
                        "",
                        service == "TUTTI" ? "" : service,
                      )
                } else {
                  this.props.getRefills(e, perPage)
                }
              }}
              total={
                Object.keys(paymentsPages).length === 0
                  ? 1
                  : paymentsPages.total_pages * 10
              }
            />
            <Select
              defaultValue={25}
              onChange={(e) => {
                const isCard =
                  this.state.paymentMethod === "card"
                    ? true
                    : this.state.paymentMethod === "wallet"
                      ? false
                      : null

                this.setState({ perPage: parseInt(e) })
                if (tableType === 1) {
                  forAdmin
                    ? getPayments(
                        username !== "" ? username : "",
                        from || today,
                        to || today,
                        1,
                        e,
                        this.props.activeSkinId === -1
                          ? null
                          : this.props.activeSkinId,
                        "",
                        service == "TUTTI" ? "" : service,
                        null,
                        activeCategory !== "TUTTI" ? activeCategory : null,
                        null,
                        this.state.provider ? this.state.provider : "",
                        this.props.activeSkinId === -1 ? true : null,
                        isCard,
                      )
                    : getPayments(
                        username !== "" ? username : "",
                        from || today,
                        to || today,
                        1,
                        e,
                        "",
                        "",
                        service == "TUTTI" ? "" : service,
                      )
                } else {
                  this.props.getRefills(1, e)
                }
              }}
            >
              <Option value={10}>10 / Pagina</Option>
              <Option value={25}>25 / Pagina</Option>
              <Option value={50}>50 / Pagina</Option>
              <Option value={100}>100 / Pagina</Option>
            </Select>
          </div>
        }
      </>
    )
  }
}

const mapStateToProps = (state) => ({
  accountInfo: state.auth.accountInfo,
  payments: state.auth.payments,
  loadingPayments: state.auth.loadingPayments,
  paymentsFromCode: state.auth.paymentsFromCode,
  paymentsPages: state.auth.paymentsPages,
  screenWidth: state.main.screenWidth,
  paymentsForExcel: state.auth.paymentsForExcel,
  paymentExcelLoading: state.auth.paymentExcelLoading,
  fromDate: state.auth.fromDate,
  usernames: state.auth.usernames,
  services: state.auth.listed_services,
  stat: state.auth.Statistiche?.total,
  allServices: state.auth.allServices.data,
  services: state.auth.allServices.services,
  listedServices: state.auth.listed_services,
  skinList: state.auth.skinList,
  servicesTree: state.main.servicesTree,
  brands: state.auth.brands,
  balance: state.auth.balance,
  listedProviders: state.auth.listed_providers,
  selectedCompany: state.main.selectedCompany,
})

export default connect(mapStateToProps, { ...MainActions, ...AuthActions })(
  withRouter(TransazioniAdmin),
)
